import { useAppSelector, useAppDispatch } from "@/services/hooks";
import { useCurrentPermission } from "@/services/userServices/useCurrentPermission";
import React, { useEffect, useMemo, useState } from "react";

import {
  addBlog,
  getBlog,
  updateBlog,
  getPosts,
  changeStatus,
  updatePostStatus,
  deleteBlog,
  clearMessage,
} from "@/services/blogServices/blogActions";
import NotificationAlertOptions from "@/layouts/Alerts";
import CreateBlogView from "./createblogView";

const CreateBlogContainer = () => {
  const dispatch = useAppDispatch();
  const blogState = useAppSelector((s) => s.blog);
  const errorsState = useAppSelector((s) => s.errors);
  const permission = useCurrentPermission();
  const profile = useAppSelector((s) => s.profile);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [_id, setId] = useState("");
  const [viewAddButton, setViewAddButton] = useState(false);
  const [viewUpdateButton, setViewUpdateButton] = useState(false);
  const [validation, setValidation] = useState({ title: true });
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    dispatch(getBlog());
    dispatch(getPosts());
  }, [dispatch]);

  const blogEntity = useMemo(() => {
    const b = blogState?.blog ?? blogState;
    if (!b) return null;
    if (Array.isArray(b)) return b[0] || null;
    if (typeof b === "object") return Object.keys(b).length ? b : null;
    return null;
  }, [blogState]);

  useEffect(() => {
    if (!blogEntity) {
      setViewAddButton(true);
      setViewUpdateButton(false);
      return;
    }
    setViewAddButton(false);
    setViewUpdateButton(true);
    setTitle(blogEntity.title || "");
    setDescription(blogEntity.description || "");
    setId(blogEntity._id || "");
  }, [blogEntity]);

  useEffect(() => {
    const msg = blogState?.message;
    if (msg) {
      NotificationAlertOptions("success", msg);
      dispatch(clearMessage());
    }
  }, [blogState?.message, dispatch]);

  useEffect(() => {
    const errs = errorsState?.errors;
    if (errs && errs.length) {
      const v = { ...validation };
      errs.forEach((e) => {
        if (e?.param && e?.value === "") v[e.param] = false;
      });
      setValidation(v);
    }
  }, [errorsState, dispatch]); 

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name === "title") setTitle(value);
    if (name === "description") setDescription(value);
    setValidation((prev) => ({ ...prev, [name]: true }));
  };

  const onClickAdd = () => {
    dispatch(addBlog({ title, description }));
  };

  const onClickUpdate = (e) => {
    e.preventDefault();
    const id = _id || blogEntity?._id;
    if (!id) return;
    dispatch(updateBlog({ title, description, _id: id }));
  };

  return (
    <CreateBlogView
      alert={alert}
      title={title}
      description={description}
      validation={validation}
      viewAddButton={viewAddButton}
      viewUpdateButton={viewUpdateButton}
      permission={permission || {}}
      onChange={onChange}
      onClickAdd={onClickAdd}
      onClickUpdate={onClickUpdate}
    />
  );
};

export default CreateBlogContainer;
